import { forwardRef } from 'react';

import { Dialog } from '@/components/atoms';
import { DialogDescriptionProps } from '@/components/atoms/Dialog/DialogDescription';
import { cn } from '@/lib/utils/tailwind';

type SheetDescriptionProps = DialogDescriptionProps;

const SheetDescription = forwardRef<
  HTMLParagraphElement,
  SheetDescriptionProps
>(({ children, className, ...props }, ref) => (
  <Dialog.Description
    className={cn('text-muted-foreground text-sm', className)}
    ref={ref}
    {...props}
  >
    {children}
  </Dialog.Description>
));
SheetDescription.displayName = 'SheetDescription';

export { SheetDescription, type SheetDescriptionProps };
